export * from './SearchResultsComponent';
